import { UpdateOffer } from "../Model/Offer";
import { OffersPromoRepository } from "../Repository/OffersPromoRepository";

export interface UpdateOfferImagesUseCase {
    invoke: (id: number, data: UpdateOffer) => Promise<boolean>;
  }
  
  export class UpdateOfferImages implements UpdateOfferImagesUseCase {
    private Repo: OffersPromoRepository;
    constructor(_Repo: OffersPromoRepository) {
      this.Repo = _Repo;
    }
  
    async invoke(id: number ,data: UpdateOffer){
       
        if(!id){
            throw new Error(
                "Your todo should have at leat 2 characters."
              );
        }
         
        const update  = await this.Repo.updateOfferImages(id, data);
        return update;
    }
  }